function multiselect () {
  const PARENT_CLASS = 'js-multiselect';
  const SELECT_CLASS = 'js-multiselect-select';
  const SELECTED_CLASS = 'js-multiselect-selected';
  const SELECTED_ITEM_CLASS = 'js-multiselect-item';
  const SELECTED_REMOVE_CLASS = 'js-multiselect-remove';

  const selectParents = [...document.querySelectorAll(`.${PARENT_CLASS}`)];
  if (!selectParents.length) return;

  const selects = selectParents.map(parent => parent.querySelector(`.${SELECT_CLASS}`));
  const choices = {};
  // фабрика карточек выбранного
  const renderSelected = (name, value) => {
    const item = document.createElement('li');
    item.classList.add('multiselect__selected-item', SELECTED_ITEM_CLASS);
    item.dataset.value = value;
    item.innerHTML = `
      <p class="multiselect__selected-text">${name}</p>
      <button class="multiselect__selected-button ${SELECTED_REMOVE_CLASS}" type="button">
          <span class="visually-hidden">Удалить</span>
      </button>
    `;
    return item;
  };
  // синхронизация мультиселекта и списка выбранных
  const syncSelect = (choice) => {
    const select = choice.passedElement.element;
    const selected = select.closest(`.${PARENT_CLASS}`).querySelector(`.${SELECTED_CLASS}`);
    select.addEventListener('addItem', (evt) => {
      selected.prepend(renderSelected(evt.detail.label, evt.detail.value));
    });
    select.addEventListener('removeItem', (evt) => {
      const item = selected.querySelector(`.${SELECTED_ITEM_CLASS}[data-value="${evt.detail.value}"]`);
      if (!item) return;
      item.remove();
    });
    selected.addEventListener('click', (evt) => {
      if (!evt.target.matches(`.${SELECTED_REMOVE_CLASS}`)) return;
      evt.preventDefault();
      const item = evt.target.closest(`.${SELECTED_ITEM_CLASS}`);
      const value = item.dataset.value + '';
      item.remove();
      choice.removeActiveItemsByValue(value);
    });
  };
  // конфиг
  const getChoicesConfig = (select) => {
    const type = select.dataset.type;
    const maxItemCount = select.dataset.maxCount ? select.dataset.maxCount : -1;

    const choicesConfig = {
      single: {
        classNames: {
          listDropdown: 'choices__dropdown',
        listSingle: 'choices__list--single choices__selected-list stats__filter-input stats__filter-select',
        inputCloned: 'choices__search',
        itemSelectable: 'choices__selected',
        activeState: 'active',
        openState: 'open',
      },
      searchPlaceholderValue: 'Поиск места проведения экзамена',
      noResultsText: 'Совпадений не найдено',
      callbackOnInit: function () {
        this.passedElement.element.addEventListener('change', () => {
          this.itemList.element.style.color = '#3b4256';
        });
      },
    },
    multiple: {
      maxItemCount: maxItemCount,
      maxItemText: (maxItemCount) => {
        return `Максимальное количество - ${maxItemCount}`;
      },
      removeItems: true,
      removeItemButton: true,
      searchResultLimit: 100,
      noResultsText: 'Совпадений не найдено',
      noChoicesText: 'Выберите место проведения экзамена',
      classNames: {
        listDropdown: 'choices__dropdown',
        listSingle: 'choices__list--single choices__selected-list multiselect__select',
        inputCloned: `choices__search`,
        itemSelectable: 'choices__selected',
        activeState: 'active',
        openState: 'open',
      },
      callbackOnInit: function () {
        const choice = this;
        // модификации DOM списка
        this.dropdown.element.prepend(this.containerInner.element);
        this.input.element.placeholder = 'Поиск ';
        const choosedTitle = document.createElement('div');
        choosedTitle.classList.add('multiselect__select-title-wrap');
        let text;
        if (this.config.maxItemCount > 0) {
          text = `
            <p class="multiselect__select-title">Выбранные</p>
            <p class="multiselect__select-info">Максимальное количество — ${this.config.maxItemCount}</p>
          `;
        } else {
          text = `
            <p class="multiselect__select-title">Выбранные</p>
            <p class="multiselect__select-info"></p>
          `;
        }
        choosedTitle.innerHTML = text;
        this.containerInner.element.prepend(choosedTitle);
        const choicesTitle = document.createElement('div');
        choicesTitle.classList.add('multiselect__select-title-wrap');
        choicesTitle.innerHTML = '<p class="multiselect__select-title">Список</p>';
        this.dropdown.element.insertBefore(choicesTitle, this.choiceList.element);
        syncSelect(choice);
        // отрисовка выбранных по дефолту
        const selectedItems = this.getValue();
        if (!selectedItems.length) return;
        selectedItems.forEach(item => {
          const itemElement = renderSelected(item.label, item.value);
          const selected = this.passedElement.element.closest(`.${PARENT_CLASS}`).querySelector(`.${SELECTED_CLASS}`);
          selected.prepend(itemElement);
        });
      },
    },
  };
  return choicesConfig[type];
  };
  // init multiselects
  selects.forEach((element) => {
    const id = element.dataset.id;
    choices[id] = new Choices(element, getChoicesConfig(element));
  });
}
